import {useParams} from 'react-router-dom';

import {statusPageAPI} from 'features/statusPage/api/statusPageAPI';

export const usePublicStatusPage = () => {
    const {slug} = useParams();
    const {data, isLoading, isError} = statusPageAPI.useGetStatusPageViewQuery(slug ?? '', {skip: !slug});
    const [fetchPdf, {isFetching: isPdfLoading}] = statusPageAPI.useLazyGetStatusPagePdfQuery();

    const handleDownloadPdf = async() => {
        if (!slug || isPdfLoading) {
            return;
        }
        try {
            const {url} = await fetchPdf(slug).unwrap();
            window.location.href = url;
        } catch {
        }
    };

    return {
        data,
        isLoading,
        isNotFound: isError || !data,
        isPdfLoading,
        onDownloadPdf: slug ? handleDownloadPdf : undefined,
    };
};

export default usePublicStatusPage;
